import { NgModule } from '@angular/core';
import { McColorDirective } from './mc-color.directive';

@NgModule({
  declarations: [McColorDirective],
  exports: [McColorDirective]
})
export class McColorModule {}
